/**
 * `/studio/clients/$slug/blog/$widgetRef/$postRef` — one of a client's posts, in the
 * studio's editor. `pages/blog/PostEditorPage.tsx` through `StudioBlog`; the index
 * beside this file says why the client segment is `$slug_`.
 */

import { isRef } from '@fareast/shared'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { NotFound } from '../../../../../../errors/NotFound.js'
import { PostEditorPage } from '../../../../../../pages/blog/PostEditorPage.js'
import { StudioBlog } from '../../../../../../pages/studio/blog/StudioBlog.js'

export const Route = createFileRoute('/studio/clients/$slug_/blog/$widgetRef/$postRef')({
  beforeLoad: ({ params }) => {
    if (
      !isRef('client', params.slug) ||
      !isRef('widget', params.widgetRef) ||
      !isRef('post', params.postRef)
    ) {
      throw notFound()
    }
  },
  /** R3-13: the boundary is this route, so the studio shell outlives the refusal. */
  notFoundComponent: NotFound,
  component: StudioPostRoute,
})

function StudioPostRoute() {
  const { slug, widgetRef, postRef } = Route.useParams()
  return (
    <StudioBlog slug={slug} widgetRef={widgetRef}>
      <PostEditorPage postRef={postRef} />
    </StudioBlog>
  )
}
